var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.meetGreetReady || _vm.loading)?_c('loading-spinner',{attrs:{"full-page":""}}):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }